const MANAGE_DATA_CREDITS_PAGE_LINK = 'https://account.similarweb.com/data-management';

export const onGoToManageDataCreditsPage = () => window.open(MANAGE_DATA_CREDITS_PAGE_LINK, '_blank');
